<template>
  <div class="vip-banner">
    <img
      class="icon"
      crossorigin="anonymous"
      src="https://mobvoi-backend-meishe-public.mobvoi.com/moyin-mp-cdn/images/member/vip-banner-icon.png"
    />
    <span class="activity">会员日</span>
    <span class="activity discount">会员专享</span>
    <div class="countdown-box">
      距离结束还剩
      <div class="countdown">
        <div class="time-box">{{ timeObj.hour }}</div>
        <span class="time-txt">:</span>
        <div class="time-box">{{ timeObj.min }}</div>
        <span class="time-txt">:</span>
        <div class="time-box">{{ timeObj.second }}</div>
      </div>
    </div>
    <div class="more-btn" @click.stop="gotoVipDay">
      查看更多
      <img :src="packupWhite" />
    </div>
  </div>
</template>
<script>
import Component from "vue-class-component";
import { getQueryString } from "@/utils/location";
import moduleStore from "../../memberDay/store/memberDay";
import Vue from "vue";
/**components**/
@Component({
  props: {},
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class vipBanner extends Vue {
  packupWhite = require("/public/images/icon_packup-white@2x.png");

  timeObj = {
    day: "1",
    hour: "00",
    min: "00",
    second: "00",
  };
  isStart = false;
  timer = null;
  mounted() {
    this.getActivityTime();
  }
  beforeDestroy() {
    clearTimeout(this.timer);
  }
  // 获取活动时间
  getActivityTime() {
    this.$http("getCountdownTime").then((res) => {
      if (res.code === 200) {
        const { startTime, endTime } = res.data;

        // 处理时间
        const nowDate = new Date();
        if (startTime) {
          if (startTime > nowDate.getTime()) {
            // 未开始
            this.isStart = false;
          } else if (endTime && endTime < nowDate.getTime()) {
            // 已结束
            this.isStart = false;
          } else {
            // 正在进行
            this.isStart = true;
            this.countdown(endTime);
          }
        }
      }
    });
  }
  // 倒计时
  countdown(time) {
    const endDate = new Date(time);
    const now = new Date();
    const remainTime = Math.abs(endDate - now);
    if (remainTime <= 0) {
      console.log("倒计时结束");
      clearTimeout(this.timer);
      this.isStart = false;
      return;
    }
    const days = Math.floor(remainTime / (1000 * 60 * 60 * 24));
    const hours =
      Math.floor((remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10
        ? "0" +
          Math.floor((remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        : Math.floor((remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes =
      Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60)) < 10
        ? "0" + Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60))
        : Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds =
      Math.floor((remainTime % (1000 * 60)) / 1000) < 10
        ? "0" + Math.floor((remainTime % (1000 * 60)) / 1000)
        : Math.floor((remainTime % (1000 * 60)) / 1000);
    this.timeObj = {
      day: days,
      hour: hours,
      min: minutes,
      second: seconds,
    };
    this.timer = setTimeout(() => {
      this.countdown(time);
    }, 1000);
  }
  gotoVipDay() {
    this.$router.push({
      path: "/memberDay",
      query: {
        ww_token: getQueryString("ww_token") || localStorage.getItem("ww_token"),
      },
    });
  }
}
</script>
<style lang="less" scoped>
.vip-banner {
  margin-top: 12px;
  height: 64px;
  background: linear-gradient(90deg, #ff8484 0%, #ff5a9f 7%, #9154ff 100%);
  display: flex;
  align-items: center;
  padding: 0 18px;
  .icon {
    width: 26px;
    height: 26px;
    margin-right: 8px;
  }
  .activity {
    font-size: 24px;
    font-family: HarmonyOS_Sans_SC_Bold;
    color: #ffffff;
    line-height: 64px;
    &.discount {
      background: linear-gradient(
        115deg,
        #ffe29a 0%,
        #fff2d3 32%,
        #ffe8ad 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-left: 12px;
    }
  }
  .countdown-box {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-family: HarmonyOS_Sans_SC_Medium;
    color: #ffffff;
    line-height: 40px;
    margin-left: 16px;
    .countdown {
      display: flex;
      align-content: center;
      margin-left: 12px;
      .time-box {
        width: 36px;
        height: 36px;
        background: linear-gradient(306deg, #150000 0%, #ff4eb7 100%);
        border-radius: 8px;
        font-size: 24px;
        font-family: HarmonyOS_Sans_SC_Bold;
        color: #ffd661;
        line-height: 36px;
        text-align: center;
      }
      .time-txt {
        margin: 0 8px;
        line-height: 36px;
      }
    }
  }
  .more-btn {
    display: flex;
    align-items: center;
    border-radius: 26px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    padding: 9px 16px 8px;
    font-size: 24px;
    font-family: HarmonyOS_Sans_SC_Medium;
    color: #ffffff;
    margin-left: auto;
    display: flex;
    align-items: center;
    img {
      width: 14px;
      height: 24px;
      margin-left: 10px;
    }
  }
}
</style>
